import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { ApisService } from '../../services/apis.service';

@Component({
  selector: 'app-jockey-claim',
  templateUrl: './jockey-claim.component.html',
  styleUrls: ['./jockey-claim.component.scss']
})

export class JockeyClaimComponent implements OnInit {

  @ViewChild('jockeyClaim') jockeyClaimElement: ElementRef;
  @Input() jockey;
  meta: {
    saving: boolean,
    enableSave: boolean
  };
  disableReadScale = false;
  userId: number;
  jockeyWeights: {
    jockeyClaim: string
  };

  constructor(
    public activeModal: NgbActiveModal,
    private apiService: ApisService,
    private notification: ToastrService
  ) { }

  ngOnInit() {
    // console.log('[ DEBUG ] Data received:', this.jockey);
    this.meta = {
      saving: false,
      enableSave: false
    };
    this.jockeyWeights = {
      jockeyClaim: null
    };

    this.apiService.observableLoggedIn.subscribe(data => {
      this.userId = data.user_id;
    });

    this.jockeyClaimElement.nativeElement.focus();
  }

  checkClaim(newValue): void {
    this.jockeyWeights.jockeyClaim = newValue;
    this.meta.enableSave = newValue >= 0 && newValue <= 10;
  }

  resetWeighOut() {
    return new Promise((resolve, reject) => {
      const payload = {
        animalId: this.jockey.animalId,
        jockeyId: Number(this.jockey.jockeyId),
        yearOfRace: this.jockey.yearOfRace,
        raceId: this.jockey.raceId,
        divisionSequence: this.jockey.divisionSequence,
        weightDisplayed: null,
        jockeyOverweight: null,
        raw: null,
        weighed: 'O',
        type: 'M',
        updatedBy: this.userId
      };
      console.log(`[ DEBUG ] Resetting weigh-out:`, payload);
      this.apiService.updateJockeyWeights(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
        .subscribe(
          res => resolve(res),
          err => reject(err)
        );
    });
  }

  confirm() {
    this.meta.saving = true;
    const payload = {
      animalId: this.jockey.animalId,
      // jockeyId: this.jockey.jockeyId,
      yearOfRace: this.jockey.yearOfRace,
      raceId: this.jockey.raceId,
      divisionSequence: this.jockey.divisionSequence,
      jockeyClaim: this.jockeyWeights.jockeyClaim,
      updatedBy: this.userId
    };
    this.apiService.updateJockeyClaim(payload.yearOfRace, payload.raceId, payload.divisionSequence, payload.animalId, payload)
      .subscribe(
        resJockeyClaim => {
          // console.log('[ DEBUG ] Jockey Data Saved:', res);
          this.notification.success(`${this.jockey.jockeyName} weight claim has been saved.`, 'Weight Claim');
          if (this.jockey.weights['O'].weightRecorded) {
            this.notification.warning(`${this.jockey.jockeyName} was already weighted out. ` +
            `Please weight it out again with the updated claim.`, 'Weigh-Out', { timeOut: 6000 });
            this.resetWeighOut()
            .then(resWeighOut => {
              resJockeyClaim.resetWeighOut = true;
              this.meta.saving = false;
              this.activeModal.close(resJockeyClaim);
            })
            .catch(errWeighOut => {
              console.error('[ DEBUG ] Error resetting weigh-out after changing Jockey', errWeighOut);
              this.meta.saving = false;
              resJockeyClaim.resetWeighOut = false;
              this.activeModal.close(resJockeyClaim);
              this.notification.error(`Could't reset the weigh-out of the Jockey. Please remember to weigh-out again.`,
              'Weigh-Out', { disableTimeOut: true });
            });
          } else {
            this.meta.saving = false;
            this.activeModal.close(resJockeyClaim);
          }
        },
        err => {
          console.error('[ DEBUG ] Error updating Jockey', err);
          this.notification.error(`Could't save the weight claim. Check your connection and Try again.`, 'Weight Claim');
          this.meta.saving = false;
        }
      );
  }

  cancel(action) {
    this.activeModal.dismiss(action);
  }
}
